/**
 * ClientContextLine — household name + Plannr account UUID for ops triggers.
 */
import React from "react";

interface ClientContextLineProps {
  displayName?: string | null;
  accountUuid?: string | null;
  className?: string;
}

export function ClientContextLine({
  displayName,
  accountUuid,
  className = "",
}: ClientContextLineProps) {
  if (!displayName && !accountUuid) return null;
  return (
    <p
      className={`text-xs text-slate-600 dark:text-slate-300 truncate ${className}`}
      data-testid="client-context-line"
    >
      {displayName && (
        <span className="font-medium text-slate-800 dark:text-slate-100">
          {displayName}
        </span>
      )}
      {displayName && accountUuid && (
        <span className="text-slate-400 dark:text-slate-500 mx-1.5">·</span>
      )}
      {accountUuid && (
        <code className="text-[11px] font-mono text-slate-500 dark:text-slate-400">
          {accountUuid}
        </code>
      )}
    </p>
  );
}
